export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/components/switch-v2/SwitchV2.tsx"